import React from "react";
// import  Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import moment from "moment";
import FdTypography from "../UIComponents/Typography/FdTypography";

export interface Props {
  dateTime: Date;
}

const EventModificationTime = ({ dateTime }: Props) => {
  return (
    <Box display="flex">
      <FdTypography
        label="Last Saved:"
        variant="body2"
        align="center"
        color="text.primary"
        fontWeight="bold"
      /> &nbsp;
      <FdTypography
        label=
            {moment.utc(dateTime).fromNow()}
        
        variant="body2"
        align="center"
        color="text.primary"
      />
    </Box>
  );
};

export default EventModificationTime;
